import type { Locale } from '@/stores/language'

import { SITE_URL } from './platform-urls'

// The marketing site serves English at the ROOT (no /en/ prefix — Astro
// prefixDefaultLocale: false); only pt-br is prefixed.
const SLUGS = {
  terms: {
    ptBr: '/pt-br/termos-de-uso/',
    en: '/terms-of-service/',
  },
  cookies: {
    ptBr: '/pt-br/politica-de-cookies/',
    en: '/cookie-policy/',
  },
  privacy: {
    ptBr: '/pt-br/politica-de-privacidade/',
    en: '/privacy-policy/',
  },
  plans: {
    ptBr: '/pt-br/planos/',
    en: '/pricing/',
  },
  affiliates: {
    ptBr: '/pt-br/afiliados/',
    en: '/affiliates/',
  },
  affiliateTerms: {
    ptBr: '/pt-br/termos-de-afiliados/',
    en: '/affiliate-terms/',
  },
  resellerTerms: {
    ptBr: '/pt-br/termos-de-revenda/',
    en: '/reseller-terms/',
  },
  badgeAbout: {
    ptBr: '/pt-br/selo-de-sustentabilidade-signater/',
    en: '/signater-sustainability-badge/',
  },
  envelopeAccess: {
    ptBr: '/pt-br/acesso-ao-envelope/',
    en: '/envelope-access/',
  },
} as const

export type MarketingPath = keyof typeof SLUGS

export function getMarketingUrl(path: MarketingPath, locale: Locale): string {
  const key = locale === 'ptBr' ? 'ptBr' : 'en'
  return `${SITE_URL}${SLUGS[path][key]}`
}

export const MARKETING_HOME = SITE_URL
export const ASSETS_BASE = 'https://assets.signater.com'
